import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, switchMap, tap } from 'rxjs';

@Injectable()
export class GraphqlTokenInterceptor implements HttpInterceptor {
  readonly GRAPHQL_API: string = 'https://graph-api'
  constructor(private authService: MsalService) {}

  intercept(req: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(this.GRAPHQL_API)) {
      const accessTokenRequest = {
        scopes: ['user.read'],
        account: this.authService.instance.getAllAccounts()[0],
      };
      return this.authService.acquireTokenSilent(accessTokenRequest).pipe(
        switchMap((token) => {
          const modifiedReq = req.clone({
            headers: req.headers.set('Authorization', `${token.idToken}`),
          });
          return next.handle(modifiedReq);
        })
      );
    }
    return next.handle(req);
  }
}
